import { forwardRef, type Ref, type SVGProps } from "react";
const IconSwipeFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m6.42 9.71-1-1H9.5a1 1 0 1 0 0-2H5.41l1-1A1 1 0 0 0 5 4.29L2.29 7a.9.9 0 0 0-.21.33 1 1 0 0 0 0 .76q.076.183.21.33L5 11.12a1 1 0 0 0 .71.3 1 1 0 0 0 .71-.3 1 1 0 0 0 0-1.41" />
    <path d="M29.92 8.09a1 1 0 0 0 0-.76.9.9 0 0 0-.21-.33L27 4.29a1.004 1.004 0 1 0-1.42 1.42l1 1H22.5a1 1 0 1 0 0 2h4.09l-1 1a1 1 0 0 0 0 1.41 1 1 0 0 0 .71.3 1 1 0 0 0 .71-.3l2.71-2.7a1.2 1.2 0 0 0 .2-.33" />
    <path d="m25.59 14.47-6.13-.78V8.53a3.46 3.46 0 1 0-6.91 0v10.72c-1-.45-1.79-.82-1.94-.88a3.45 3.45 0 0 0-3.92 1.19A3.4 3.4 0 0 0 6 22.12a3.45 3.45 0 0 0 1.38 2.28l6.55 4.91A3.46 3.46 0 0 0 16 30h9.57a2.64 2.64 0 0 0 2.62-2.31l1.06-8.45a4.3 4.3 0 0 0-3.66-4.77" />
  </svg>
);
const ForwardRef = forwardRef(IconSwipeFilledSVG);
ForwardRef.displayName = "IconSwipeFilled";
export { ForwardRef as IconSwipeFilled };
